<template>
  <Control :title="title" :isEdit="true"  :tooltip="tooltip"  :key="title">
    <template slot="edit">
      <div class="cx_filterbox">
        <b-form-input ref="target" v-model="internalValue" type="text" :placeholder="placeholder" autocomplete="off" size="sm"></b-form-input>
        <b-button @click="OnClick">
          <i class="material-symbols-outlined small valign">search</i>
        </b-button>
      </div>
    </template>
  </Control>
</template>
<script lang="ts">
import { Component, Vue, Prop,Emit } from 'vue-property-decorator';
import * as Components from '@/agiles/components';

@Component
export default class FilterBox extends Vue {

  @Prop({default:''}) public title?: string;
  @Prop({default:null}) public value?: string;
  @Prop({default:''}) public placeholder?: string;
  @Prop({ default: null }) public nullValue: any;
  @Prop({ default: false }) public isNumber: boolean;
  @Prop() public tooltip: string;

  public get internalValue(): string {
    return this.value;
  }
  
  @Emit('click')
  public OnClick() {}

  public set internalValue(value: string) {
    //数値フラグONで数値に変換できない場合にnullValueをセット
    if (this.isNumber && isNaN(Number.parseFloat(value))){
      this.$emit('update:value', this.nullValue);
    } else {
      // 親コンポーネント側で更新
      this.$emit('update:value', value);
    }

  }
}

</script>
<style lang="scss">
.cx_filterbox{
    display: flex;

    input.form-control-sm {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-right:none;
    }
    button{
           padding: 1px 2px;
            font-size: 14px;
            line-height: 16px;
                    border-top-left-radius: 0rem;
        border-bottom-left-radius: 0rem;
    }
}
</style>